import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextInput from '../textInput/textInput';
import CloseButton from '../closeButton/closeButton';
import { dataHooks } from './constants';

var SearchSymbol = function SearchSymbol(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "15",
    height: "15",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F3343",
    d: "M9.58 8.97c.85-.97 1.29-2.18 1.29-3.54 0-3-2.43-5.43-5.44-5.43C2.43 0 0 2.43 0 5.43a5.43 5.43 0 0 0 5.43 5.44c1.36 0 2.62-.41 3.6-1.25L11.41 12l.59-.59-2.42-2.44zm-4.15 1.06C2.9 10.03.84 7.97.84 5.43.84 2.9 2.9.84 5.43.84c2.54 0 4.6 2.06 4.6 4.59a4.6 4.6 0 0 1-4.6 4.6z"
  }));
};

var Search = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Search, _React$PureComponent);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.call(this, props);
    _this.state = {
      showOptions: false,
      active: null,
      isSelectedViaKeyboard: false
    };
    _this.activeListItemRef = /*#__PURE__*/React.createRef();
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onItemClick = _this._onItemClick.bind(_assertThisInitialized(_this));
    _this._onEnter = _this._onEnter.bind(_assertThisInitialized(_this));
    _this._onKeyDown = _this._onKeyDown.bind(_assertThisInitialized(_this));
    _this._onClear = _this._onClear.bind(_assertThisInitialized(_this));
    _this._resetActiveIndex = _this._resetActiveIndex.bind(_assertThisInitialized(_this));
    _this._insureVisibility = _this._insureVisibility.bind(_assertThisInitialized(_this));
    _this._renderOptions = _this._renderOptions.bind(_assertThisInitialized(_this));
    _this._onMouseMove = _this._onMouseMove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Search, [{
    key: "_highlight",
    value: function _highlight(subject, match) {
      return subject.replace(new RegExp(match, 'i'), '<strong>$&</strong>').replace(/> /g, '>&nbsp;');
    }
  }, {
    key: "_onFocus",
    value: function _onFocus() {
      this.setState({
        showOptions: true
      });
      this.setState({
        active: null
      });
    }
  }, {
    key: "_onBlur",
    value: function _onBlur() {
      this.setState({
        showOptions: false
      });
    }
  }, {
    key: "_onChange",
    value: function _onChange(value) {
      this.props.onChange(value);

      this._resetActiveIndex();
    }
  }, {
    key: "_onItemClick",
    value: function _onItemClick(value) {
      this.props.onItemClick(value);
    }
  }, {
    key: "_onEnter",
    value: function _onEnter(value) {
      return this.props.onEnter ? this.props.onEnter(value) : this.props.onItemClick(value);
    }
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown(e, blur) {
      var options = this.props.options;
      var active = this.state.active;

      switch (e.key) {
        case 'Enter':
          {
            if (active !== null) {
              e.preventDefault();

              this._onEnter(options[active]);

              blur(); // Callback from the TextInput
            }

            break;
          }

        case 'ArrowDown':
          {
            e.preventDefault();
            var newActiveIndex = (active + 1) % options.length;
            this.setState({
              active: newActiveIndex,
              isSelectedViaKeyboard: true
            }, this._insureVisibility);
            break;
          }

        case 'ArrowUp':
          {
            e.preventDefault();

            var _newActiveIndex = active === 0 ? options.length - 1 : active - 1;

            this.setState({
              active: _newActiveIndex,
              isSelectedViaKeyboard: true
            }, this._insureVisibility);
            break;
          }

        default:
          break;
      }
    }
  }, {
    key: "_onMouseMove",
    value: function _onMouseMove() {
      var isSelectedViaKeyboard = this.state.isSelectedViaKeyboard;

      if (!isSelectedViaKeyboard) {
        return;
      }

      this.setState({
        isSelectedViaKeyboard: false
      });
    }
  }, {
    key: "_onClear",
    value: function _onClear() {
      this.props.onClear();
    }
  }, {
    key: "_resetActiveIndex",
    value: function _resetActiveIndex() {
      this.setState({
        active: 0
      });
    }
  }, {
    key: "_insureVisibility",
    value: function _insureVisibility() {
      if (this.activeListItemRef.current) {
        this.activeListItemRef.current.scrollIntoView({
          behavior: 'auto',
          block: 'nearest'
        });
      }
    }
  }, {
    key: "_renderOptions",
    value: function _renderOptions() {
      var _this2 = this;

      var _this$props = this.props,
          options = _this$props.options,
          value = _this$props.value;
      return /*#__PURE__*/React.createElement("ul", {
        className: "control-search-options",
        onMouseMove: this._onMouseMove
      }, options.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: item,
          "data-hook": dataHooks.controlSearchOption(index),
          ref: index === _this2.state.active ? _this2.activeListItemRef : null,
          className: "control-search-options__item ".concat(index === _this2.state.active ? 'active' : ''),
          onMouseDown: function onMouseDown() {
            _this2._onItemClick(item);
          },
          onMouseEnter: function onMouseEnter() {
            return (// Insures that onMouseEnter is not fiered after ScrollIntoView caused by keyboard navigation
              !_this2.state.isSelectedViaKeyboard && _this2.setState({
                active: index
              })
            );
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "control-search-options__item-content",
          dangerouslySetInnerHTML: {
            __html: _this2._highlight(item, value)
          }
        }));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          getClassName = _this$props2.getClassName,
          dataHook = _this$props2.dataHook,
          value = _this$props2.value,
          placeholder = _this$props2.placeholder,
          clearButton = _this$props2.clearButton,
          focus = _this$props2.focus;
      var showOptions = this.state.showOptions;
      return /*#__PURE__*/React.createElement("div", {
        className: getClassName('control-search'),
        "data-hook": dataHook
      }, /*#__PURE__*/React.createElement("div", {
        className: "control-search-input"
      }, /*#__PURE__*/React.createElement(TextInput, {
        value: value,
        automationId: 'control-search-input',
        placeholder: placeholder,
        onChange: this._onChange,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        focus: focus,
        onKeyDown: this._onKeyDown
      }), /*#__PURE__*/React.createElement("span", {
        className: "control-search-input__prefix"
      }, /*#__PURE__*/React.createElement(SearchSymbol, {
        className: "control-search-input__symbol"
      })), clearButton && value && /*#__PURE__*/React.createElement("span", {
        className: "control-search-input__suffix"
      }, /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this._onClear,
        dataHook: dataHooks.searchCloseButton
      }))), value && showOptions && this._renderOptions());
    }
  }]);

  return Search;
}(React.PureComponent);

Search.displayName = displayNames.SEARCH;
Search.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** A css class to be applied to the component's root element */
  className: PropTypes.string,

  /** Value of the text input  */
  value: PropTypes.string.isRequired,

  /** Placeholder for the text input  */
  placeholder: PropTypes.string,

  /** List of items to show in dropdown  */
  options: PropTypes.arrayOf(PropTypes.string).isRequired,

  /** Callback that fiers on input change  */
  onChange: PropTypes.func.isRequired,

  /** Callback that fiers on the dropdown item click  */
  onItemClick: PropTypes.func.isRequired,

  /** Callback that fiers on the Enter key press*/
  onEnter: PropTypes.func,

  /** Callback that fiers on the clear-button key press. Defaults to onItemClick*/
  onClear: PropTypes.func,

  /** Callback that fiers on input focused */
  onFocus: PropTypes.func,

  /** Whether or not to make input focused  */
  focus: PropTypes.bool,

  /** Whether or not to display the clear button  */
  clearButton: PropTypes.bool
};
Search.defaultProps = {
  clearButton: true,
  placeholder: 'Search',
  onClear: function onClear() {},
  onEnter: function onEnter() {}
};
export default compose(Search);